import 'css-chunksrc/client/pages/projectPage/sideBar/externalLinksList/link/styles.scss';export default {
  "link": "_link_1e42a_1",
  "icon": "_icon_1e42a_11",
  "name": "_name_1e42a_19"
};